import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { CampusHeader } from '../Components/CampusHeader';
import { CampusFooter } from '../Components/CampusFooter';


class FAQ {
    key: number
    Question: string;
    Content: any;
}
const letterSpace = '2px';

const multiLineStyle: CSSProperties = {
    textAlign: 'left',
    padding: '10px'
}
const answerStyle: CSSProperties = {
    letterSpacing: 'normal',
    paddingTop: '16px',
    paddingBottom: '16px'
}

const schoolStyle: CSSProperties = {
    textDecoration: 'underline',
    color: 'blue',
    cursor: 'pointer'
}

const itemStyle: CSSProperties = {
    fontSize: '13px',
    padding: '5px',
    margin: '5px 10px',
    letterSpacing: '2px',
    borderBottom: '1px solid rgba(87,144,161,0.2)',
    fontFamily: 'BarlowLight',
    color: '#616060'
}

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: 'auto auto 200px auto',
    width: '43%'
}
const FAQHdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowLight',
    color: '#616060'
}
const questionStyle: CSSProperties = {
    fontFamily: 'Lulo',
    fontSize: '15px',
    letterSpacing: 'normal'
}

class _CampusFAQ extends React.Component<Tgcc.BaseProps, any>{

    openLicense = () => { browserHistory.push(Tgcc.Routes.OtherSchools) }

    FAQS: FAQ[] = [
        {
            key: 1,
            Question: "How do I start an apparel design?",
            Content: <div style={answerStyle}>Use our easy online proof request system or contact us at 800-472-3269. One of our custom apparel professionals will help you get started!</div>
        }, {
            key: 2,
            Question: "Is there a minimum order requirement?",
            Content: <div style={answerStyle}>Yes, we require a minimum of 36 items for all screen-printed apparel orders that do not require custom artwork. If your art design requires customization, a minimum order of 50 items may apply. All embroidery items require a minimum of 36 items.</div>

        }, {
            key: 3,
            Question: "Is artwork free?",
            Content: <div style={answerStyle}>We love providing great new designs for all of our customers, but there are certain situations where a refundable art deposit might be required. Your account manager will contact you if this might be necessary.</div>
        }, {
            key: 4,
            Question: "How do I get a quote?",
            Content: <div style={answerStyle}>We’ll provide you an accurate price quote for your order each time we send you a completed proof. If you’d like an estimate before you have a design, please contact us at sales@grafcow.com.</div>
        }, {
            key: 5,
            Question: "Can you get apparel not listed on your site?",
            Content: <div style={answerStyle}>Chances are yes! We work with distributors all over the country, so if you don’t see what you want let us know and we’ll do our best to make it happen!</div>
        }, {
            key: 6,
            Question: "How can I track my order?",
            Content: <div style={answerStyle}>We will provide you a FedEx tracking number once your product has been scanned for shipment.</div>
        }, {
            key: 7,
            Question: "Can I add to an order after it’s been processed?",
            Content: <div style={answerStyle}>We can’t guarantee it for every order but if you contact us the same business day the order closes, we will do our best to adjust.</div>
        }, {
            key: 8,
            Question: "Are you licensed with my organization and school?",
            Content: <div style={answerStyle}>We are licensed with nearly all Greek organizations and over 120+ Colleges &#38; Universities. To view a full list of our licensed schools check them out <span onClick={this.openLicense} style={schoolStyle}>here</span></div>
        }
    ];


    componentDidMount() {
        var tag = document.getElementById('FAQ');
        tag.scrollIntoView(false);
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    render() {
        return (
            <div>
                <div id="FAQ"></div>
                <CampusHeader />
                <h2 style={FAQHdr}>FAQ&#39;s</h2>
                <div style={containerStyle} className='questionCont'>
                    {this.FAQS.map((faq: FAQ) => {
                        return (<div key={faq.key} style={itemStyle}>
                            <div style={questionStyle}>{faq.Question}</div>
                            {faq.Content}
                        </div>)
                    })}
                </div>
                <CampusFooter state={this.props.state} />
            </div>

        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        state: state
    }
};
export var CampusFAQ = connect(mapStateToProps)(_CampusFAQ)